import useScript from "../../hooks/useScript";
import useInjectScript from "../../hooks/useInjectScript";

type HyperpayPaymentFormProps = {
  paymentId: string;
  redirectTo: string;
};
export default function HyperpayPaymentForm(props: HyperpayPaymentFormProps) {
  const { paymentId, redirectTo } = props;
  useScript(
    `${process.env.REACT_APP_HYPERPAY_BASE_URL}/v1/paymentWidgets.js?checkoutId=${paymentId}`
  );
  useInjectScript('var wpwlOptions = { paymentTarget: "_top" }');

  return (
    <div className="w-full bg-white mb-2 shadow h-fit overflowY-auto rounded-md p-6">
      <form
        action={redirectTo}
        className="paymentWidgets"
        data-brands="VISA MASTER"
      ></form>
      <script type="text/javascript"></script>
    </div>
  );
}
